var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"mobile-button",staticClass:"back-button",attrs:{"type":"button","aria-label":_vm.$t('navigateBack')},on:{"click":_vm.navigateBackOne}},[_c('SvgIcon',{attrs:{"name":"ChevronLeftIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }